export const IS_LOCAL_ENV = import.meta.env.VITE_APP_ENV === 'local';
export const IS_DEV_BUILD = import.meta.env.MODE === 'default'; // Only for local dev
export const SHOULD_LOAD_DEV_TOOLS = IS_LOCAL_ENV || IS_DEV_BUILD;

/**
 * Validates the returnTo URL to prevent open redirect vulnerabilities.
 * Only allows relative paths starting with '/'.
 *
 * @param {string} returnTo - The URL to validate
 * @returns {string} - Validated URL or '/' if invalid
 */
export const validateReturnTo = (returnTo) => {
  // Must be a non-empty string
  if (!returnTo || typeof returnTo !== 'string') return '/';
  // Must start with a single forward slash (relative path)
  if (!returnTo.startsWith('/')) return '/';
  // Prevent protocol-relative URLs (//example.com)
  if (returnTo.startsWith('//')) return '/';
  // Prevent javascript: or other protocol schemes encoded in the path
  if (returnTo.toLowerCase().includes('javascript:')) return '/';
  // Basic length check to prevent DoS via extremely long URLs
  if (returnTo.length > 2048) return '/';
  return returnTo;
};

export const cognitoAuthConfig = {
  authority: import.meta.env.VITE_AE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_AE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_AE_COGNITO_REDIRECT_URI,
  response_type: 'code',
  scope: 'email openid profile',
  // Clean up OAuth params from URL after signin.
  // NOTE: We intentionally do NOT navigate here using window.history.replaceState()
  // because it doesn't sync with React Router's internal state.
  // The actual navigation to returnTo is handled by AuthenticatedRouter
  // using React Router's navigate() to ensure proper synchronization.
  onSigninCallback: () => {
    // Just clean up the OAuth callback params from the URL
    // The returnTo navigation is handled by AuthenticatedRouter after auth completes
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export const LOCAL_ADMIN_EMAIL = IS_LOCAL_ENV ? 'asad.m@astrongroup.com' : '';
